<template>
  <a-card :loading="loading" :body-style="{ padding: '20px 24px 8px' }" :bordered="false">
    <div class="chart-card-header">
      <div class="meta">
        <span class="chart-card-title">
          <slot name="title">{{ title }}</slot>
          <slot name="date">
            <span v-if="dateString" class="card-date">{{ dateString }}</span>
          </slot>
        </span>
        <span class="chart-card-action">
          <slot name="action"></slot>
        </span>
      </div>
      <div class="total">
        <slot name="total">
          <countTo style="font-size: 30px; color: rgba(0,0,0,0.85);" :startVal='oldTotal || 0' :endVal='total || 0' :duration='500' :suffix="type=='progress'?'%':''" @callback="mountedCallback"></countTo>
        </slot>
      </div>
    </div>
    <div class="chart-card-content">
      <div class="content-fix">
        <slot></slot>
      </div>
    </div>
    <div class="chart-card-footer">
      <div class="field">
        <slot name="footer"></slot>
      </div>
    </div>
  </a-card>
</template>

<script>
import countTo from 'vue-count-to';
export default {
  name: "ChartCard",
  components: { countTo },
  props: {
    title: {
      type: String,
      default: "",
    },
    dateString: {
      type: String,
      default: "",
    },
    total: {
      type: [Function, Number, String],
      required: false,
      default: 0,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oldTotal: 0,
    };
  },
  methods: {
    mountedCallback() {
      this.oldTotal = this.total;
    }
  }
};
</script>

<style lang="scss" scoped>
.number {
  font-family: “Helvetica Neue”, Helvetica, Arial, “PingFang SC”,
    “Hiragino Sans GB” “Heiti SC”, “Microsoft YaHei”, “WenQuanYi Micro Hei”,
    sans-serif;
}
.chart-card-header {
  position: relative;
  overflow: hidden;
  width: 100%;

  .meta {
    position: relative;
    overflow: hidden;
    width: 100%;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
    .card-date {
      width: 78px;
      height: 18px;
      padding: 2px 8px;
      margin-left: 12px;
      font-size: 12px;
      text-align: center;
      color: rgba(0, 0, 0, 0.35);
      line-height: 18px;
      background: rgba(0, 0, 0, 0.04);
      border-radius: 1px;
      font-family: HelveticaNeue;
    }
  }
}

.chart-card-action {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
}

.chart-card-footer {
  border-top: 1px solid #e8e8e8;
  padding-top: 8px;
  margin-top: 20px;

  > * {
    position: relative;
  }

  .field {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;

    /deep/ .footer-label {
      font-size: 12px;
      margin-right: 8px;
      color: rgba($color: #000000, $alpha: 0.65);
      font-family: “Helvetica Neue”, Helvetica, Arial, “PingFang SC”,
        “Hiragino Sans GB” “Heiti SC”, “Microsoft YaHei”, “WenQuanYi Micro Hei”,
        sans-serif;
    }
    /deep/ .footer-value {
      font-size: 12px;
      margin-right: 8px;
      color: rgba($color: #000000, $alpha: 0.85);
      font-family: “Helvetica Neue”, Helvetica, Arial, “PingFang SC”,
        “Hiragino Sans GB” “Heiti SC”, “Microsoft YaHei”, “WenQuanYi Micro Hei”,
        sans-serif;
    }
  }
}

.chart-card-content {
  margin-bottom: 12px;
  position: relative;
  height: 46px;
  width: 100%;

  .content-fix {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
}

.total {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
  color: #000;
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 30px !important;
  line-height: 38px;
  height: 38px;
}
</style>
